import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
import { getLogoSrc } from './Logo';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#0B1412]" data-id="element-787" data-mp="32o48q3wk3w3d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-788" data-mp="36oxzr65apr0h">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-789" data-mp="36n3dnoiafsut">
          <div className="md:col-span-2" data-id="element-790" data-mp="3ud7h9vvh7slt">
            <Link to="/" className="inline-block mb-4" data-id="element-791" data-mp="38zaivynj750">
              {/* Footer uses the same wordmark as the navbar, recolored to brand
                  green. The artwork is used as a CSS mask so the green fills its
                  exact shape — an <img> can't be tinted, only inverted. */}
              <span role="img" aria-label="206Gravel" className="block h-10 w-40" style={{
              backgroundColor: '#04A05C',
              WebkitMaskImage: `url(${getLogoSrc(undefined, 'light')})`,
              maskImage: `url(${getLogoSrc(undefined, 'light')})`,
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'left center',
              maskPosition: 'left center',
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
              width: "382px",
              height: "48px"
            }} data-id="element-792" data-mp="29yxcjbkkrila" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" style={{
            color: "#F2EFE8"
          }} data-id="element-793" data-mp="3v5n8okwjdq1a">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-794" data-mp="817d85ghpotj">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-795" data-mp="80nrsermsiar">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-796" data-mp="hsk0skv99str">
              <li data-id="element-797" data-mp="huo3x0lbynsz">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-798" data-mp="cu0icufvez65">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-799" data-mp="qrfai6xidl1t">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-800" data-mp="mrwqdddihe01">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-801" data-mp="tt08mp9t0kpy">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-802" data-mp="yuzce09ghjnf">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-803" data-mp="yuh7ygcn3z4f">
              Products
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-804" data-mp="13r7o13og2upu">
              <li data-id="element-805" data-mp="18lk89fxqwa2n"><Link to="/?category=Base%20%26%20Compaction#materials" className="hover:text-white/70 transition-colors" data-id="element-806" data-mp="18lk6pbi3k20j">Base &amp; Compaction</Link></li>
              <li data-id="element-807" data-mp="1hkfhl0w360a6"><Link to="/?category=Clear%20%26%20Drain#materials" className="hover:text-white/70 transition-colors" data-id="element-808" data-mp="1hk5ylx9gktdz">Clear &amp; Drain</Link></li>
              <li data-id="element-809" data-mp="1mkbmd2clxvqs"><Link to="/?category=Soil%2C%20Mulch%20%26%20Org.#materials" className="hover:text-white/70 transition-colors" data-id="element-810" data-mp="1mkjw4ldfokxr">Soil, Mulch &amp; Org.</Link></li>
              <li data-id="element-811" data-mp="3obx11afeistt"><Link to="/?category=Quarry%20Rock#materials" className="hover:text-white/70 transition-colors" data-id="element-812" data-mp="3obx2lev1v0vx">Quarry Rock</Link></li>
              <li data-id="element-813" data-mp="3tai1naykfeis"><Link to="/?category=Landscape%20%26%20Decor#materials" className="hover:text-white/70 transition-colors" data-id="element-814" data-mp="3tai036ix36go">Landscape &amp; Decor</Link></li>
            </ul>
          </div>

          <div data-id="element-815" data-mp="25mu5yj17gjlk">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-816" data-mp="25n3ue26lqip5">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-817" data-mp="1wnpajlkxx6dm">
              <li data-id="element-818" data-mp="1wlm8u4afdot2">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-819" data-mp="2tdzjusnl51t8">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-820" data-mp="2pd608bh6e965">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-821" data-mp="2pajmtv7lszg0">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-822" data-mp="2fdyh17nrfkb4">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-823" data-mp="18y4o2spkvqzl">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-824" data-mp="13xqgtcvswl2m">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-825" data-mp="2rvr85h744sge">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-826" data-mp="2wo0u6m53x8de">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-827" data-mp="2wokeg9i8c8ul">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-828" data-mp="2nuxm6td8dnq5">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-829" data-mp="2nue0d1kgmf6u">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-830" data-mp="3fj7nlj9a4spx">
          <p data-id="element-831" data-mp="36knbj0y85hao">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-832" data-mp="1q6nh25i5ejut">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-833" data-mp="1q4svqq2yspq7">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-834" data-mp="1nlxx4mng2f2v">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-835" data-mp="1im32q94gn7d2">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#000000]" data-id="element-836" data-mp="zwd9vrk9cvns">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide bg-[#000000]" data-id="element-837" data-mp="zxekxw19xi5i">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[700] text-[#57534e]" data-id="element-838" data-mp="18v8itbeosjus">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-839" data-mp="g7mchve2r148">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-840" data-mp="2l8yh09jd5rgw">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-841" data-mp="2uz9xswo5bv57">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}